
    import Vue from 'vue';
    import {eventBus} from "@/services/event-bus";

    export default Vue.extend({
        props: ['value', 'label', 'allowedDates', 'readonly'],
        computed: {
            myDate: {
                get(): any {
                    return this.value;
                },
                set(val: any) {
                    this.$emit('input', val);
                }
            }
        },
        data: () => ({
            menu: false,
        }),
        errorCaptured(err: Error, vm: Vue, info: string): boolean | void {
            eventBus.$emit('error', err.message);
        }
    });
